import { Fragment } from '@app/modules/fragments/types';
import { audiogramHelpers } from './helpers';
import { AudiogramGenerationStatus } from './preview/AudiogramGenerationStatus';
import { AudiogramPreview } from './preview/AudiogramPreview';
import { AudiogramExport } from './social-export/AudiogramExport';

export function FragmentAudiogramTab({ fragment }: { fragment: Fragment }) {
  if (audiogramHelpers.isGenerationStarted(fragment)) {
    return (
      <>
        <AudiogramGenerationStatus fragment={fragment} />
        <AudiogramExport fragment={fragment} />
      </>
    );
  }

  return <AudiogramPreview fragment={fragment} />;
}
